<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group
                label="Descrição"
                label-for="v-description"
              >
                <b-form-input
                  id="v-description"
                  v-model="form.descricao"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  data-cy="description-input"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-description-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="quantidade de salas"
              rules="required"
            >
              <b-form-group
                label="Quantidade de salas"
                label-for="v-qtdSalas"
              >
                <b-form-input
                  id="v-qtdSalas"
                  v-model="form.qtdDeSala"
                  type="number"
                  :state="errors.length > 0 ? false : null"
                  placeholder="quantidade de salas"
                  data-cy="qtd-salas-input"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-qtd-salas-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            v-if="form.id"
            cols="12"
          >
            <b-form-group>
              <b-form-checkbox
                v-model="form.ativo"
                :checked="form.ativo"
                name="check-button"
                switch
                inline
                data-cy="active-checkbox"
                :disabled="!canEditOrInsert"
              >
                {{ form.ativo ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="canInsert"
            :permission-edit="canEdit"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import { verificarPermissao } from '@/auth/utils'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('unidadeAtendimentoSettingsModule', {
      unidadeAtendimento: state => state.unidadeAtendimento,
    }),
    canInsert() {
      return verificarPermissao('ROLE_UNIDADE_ATENDIMENTO_INSERIR')
    },
    canEdit() {
      return verificarPermissao('ROLE_UNIDADE_ATENDIMENTO_ATUALIZAR')
    },
    canEditOrInsert() {
      return (
        (!this.form.id && this.canInsert)
        || (this.form.id && this.canEdit)
      )
    },
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      titleForm: 'Cadastro de Unidade de Atendimento',
      required,
      form: {
        descricao: '',
        qtdDeSala: '',
        ativo: true,
      },
    }
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.unidadeAtendimento))
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
      this.$store.dispatch(
        'unidadeAtendimentoSettingsModule/resetUnidadeAtendimento',
      )
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.form.id) {
            this.$store
              .dispatch(
                'unidadeAtendimentoSettingsModule/editUnidadeAtendimento',
                this.form,
              )
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch(
                'unidadeAtendimentoSettingsModule/insertNewUnidadeAtendimento',
                this.form,
              )
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.cleanObjeto()
                this.$refs.form.reset()
              })
          }
        }
      })
    },
    cleanObjeto() {
      this.form = {
        descricao: '',
        qtdDeSala: '',
        ativo: true,
      }
    },
  },
}
</script>
